import { render, staticRenderFns } from "./take-photos_whitelight.vue?vue&type=template&id=d299af8c&scoped=true&"
import script from "./take-photos_whitelight.vue?vue&type=script&lang=ts&"
export * from "./take-photos_whitelight.vue?vue&type=script&lang=ts&"
import style0 from "./take-photos_whitelight.vue?vue&type=style&index=0&id=d299af8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d299af8c",
  null
  
)

export default component.exports